import { render } from "./WebCamUI.vue?vue&type=template&id=5ffdc46e&scoped=true"
import script from "./WebCamUI.vue?vue&type=script&lang=js"
export * from "./WebCamUI.vue?vue&type=script&lang=js"

import "./WebCamUI.vue?vue&type=style&index=0&id=5ffdc46e&lang=css"
import "./WebCamUI.vue?vue&type=style&index=1&id=5ffdc46e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffdc46e"]])

export default __exports__